import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { action, API, controller } from "api";
import { useAppContext } from "context";

// LedgerType.Operational on the server — the ledger every posting goes to.
const OPERATIONAL_LEDGER = 1;

/**
 * The selected company's ledgers, and which one is chosen.
 *
 * Defaults to the OPERATIONAL ledger, not the first one returned: that is the ledger every
 * sale, purchase and voucher posts to, so it is the one a person opening the chart of
 * accounts, the account mappings or a new voucher almost always means. Shared by those three
 * screens — /account_mapping used to render the mappings with no ledger at all and showed
 * "Data not available".
 *
 *   const { ledgers, selLedger, setSelLedger } = useCompanyLedgers();
 */
const useCompanyLedgers = () => {
  const { selCompany } = useAppContext();
  const [ledgers, setLedgers] = useState([]);
  const [selLedger, setSelLedger] = useState();

  useEffect(() => {
    if (!selCompany) return;
    let current = true;
    API(controller.Ledger + action.GetLabelsByCompany).getById(selCompany, (res) => {
      if (!current) return;
      if (res?.status !== 200) {
        toast.error(res?.msg);
        return;
      }
      const result = res?.result || [];
      setLedgers(result);
      const operational = result.find((l) => l.ledgerType === OPERATIONAL_LEDGER);
      setSelLedger((operational || result[0])?.id);
    });
    return () => {
      current = false;
    };
  }, [selCompany]);

  return { ledgers, selLedger, setSelLedger };
};

export default useCompanyLedgers;
